import { render, staticRenderFns } from "./BoxPrediction.vue?vue&type=template&id=7893dac2&"
import script from "./BoxPrediction.vue?vue&type=script&lang=js&"
export * from "./BoxPrediction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip})
